"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pedavena": {
    "90b5b8df": [{
      "hkey": "d6d914fb",
      "slug": "facen-travagola",
      "name": "Facen-Travagola",
      "primary": true,
      "skipSearch": false
    }],
    "facen": [{
      "hkey": "d6d914fb",
      "slug": "facen-travagola",
      "name": "Facen-Travagola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5c821812": [{
      "hkey": "cebf2e89",
      "slug": "colli-di-murle",
      "name": "Colli di Murle",
      "primary": true,
      "skipSearch": false
    }],
    "murle": [{
      "hkey": "cebf2e89",
      "slug": "colli-di-murle",
      "name": "Colli di Murle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "143c985b": [{
      "hkey": "89b9b38d",
      "slug": "pedavena",
      "name": "Pedavena",
      "primary": true,
      "skipSearch": false
    }],
    "norcen": [{
      "hkey": "89b9b38d",
      "slug": "pedavena",
      "name": "Pedavena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "39408936": [{
      "hkey": "89b9b38d",
      "slug": "pedavena",
      "name": "Pedavena",
      "primary": true,
      "skipSearch": false
    }],
    "sega-bassa": [{
      "hkey": "89b9b38d",
      "slug": "pedavena",
      "name": "Pedavena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ab78cc02": [{
      "hkey": "d6d914fb",
      "slug": "facen-travagola",
      "name": "Facen-Travagola",
      "primary": true,
      "skipSearch": false
    }],
    "travagola": [{
      "hkey": "d6d914fb",
      "slug": "facen-travagola",
      "name": "Facen-Travagola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pedavena"
    }]
  }
};
exports["default"] = _default;